/**
 * Loads the Authorize.Net Accept.js script on-demand.
 *
 * Important: sandbox and production each have their own script host. The
 * sandbox script will throw "INVALID_CLIENT_KEY" on production keys, and vice
 * versa — so we must pick the right host based on the backend's ANET_MODE.
 *
 *   sandbox    -> https://jstest.authorize.net/v1/Accept.js
 *   production -> https://js.authorize.net/v1/Accept.js
 */
var _loadPromise = null;
var _loadedMode = null;

export function loadAcceptJs(mode) {
  if (typeof window === "undefined") return Promise.reject(new Error("No window"));

  var resolvedMode = mode === "production" ? "production" : "sandbox";
  var scriptUrl = resolvedMode === "production"
    ? "https://js.authorize.net/v1/Accept.js"
    : "https://jstest.authorize.net/v1/Accept.js";

  // If Accept.js is already loaded for the same mode, reuse it.
  if (window.Accept && _loadedMode === resolvedMode) return Promise.resolve();

  // If a load is in-flight for the same mode, reuse it.
  if (_loadPromise && _loadedMode === resolvedMode) return _loadPromise;

  _loadedMode = resolvedMode;
  _loadPromise = new Promise(function (resolve, reject) {
    // Remove any prior Accept.js tag to avoid mode mismatch
    var existing = document.querySelector('script[data-anet-accept="1"]');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var script = document.createElement("script");
    script.src = scriptUrl;
    script.type = "text/javascript";
    script.charset = "utf-8";
    script.setAttribute("data-anet-accept", "1");
    script.onload = function () { resolve(); };
    script.onerror = function () {
      _loadPromise = null;
      reject(new Error("Failed to load Accept.js from " + scriptUrl));
    };
    document.body.appendChild(script);
  });

  return _loadPromise;
}
